import { render } from "./choose-usage.vue?vue&type=template&id=3afcec78"
import script from "./choose-usage.vue?vue&type=script&setup=true&lang=js"
export * from "./choose-usage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/choose-usage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3afcec78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3afcec78', __exports__)) {
    console.log('reload')
    api.reload('3afcec78', __exports__)
  }
  
  module.hot.accept("./choose-usage.vue?vue&type=template&id=3afcec78", () => {
    console.log('re-render')
    api.rerender('3afcec78', render)
  })

}


export default __exports__